import React from 'react';
import { Input } from 'formsy-react-components';
import ReactTelInput from 'react-tel-input';

export const PhoneInput = React.createClass({
  getInitialState() {
    return {
      phone: this.props.phone
    };
  },

  handleTextChange(phoneNumber) {
    phoneNumber = phoneNumber
      .replace(/[{()}]/g, '')
      .replace(/ /g, '')
      .replace(/-/g, '');
    this.setState({
      phone: phoneNumber
    });
  },

  render() {
    const { phone } = this.state;
    return (
      <div className="form-group row">
        Phone Number
        <ReactTelInput
          type="tel"
          defaultCountry="us"
          initialValue={this.props.phone}
          placeholder="Add phone number..."
          onChange={this.handleTextChange}
          autoFormat={true}
        />
        <Input type="hidden" name="phone" value={phone} />
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/profile/phone-input.jsx
 **/